<template>
  <div class="main">
    <header>
      <p>整装预算</p>
      <van-icon name="home-o" @click="$router.push('/')" />
    </header>
    <section>
      <div class="area">
        <p>输入面积</p>
        <div>
          <input type="number" v-model.lazy="area" @blur="blurText" />
          <span>㎡</span>
        </div>
      </div>

      <template v-if="area >= 70 && area <= 140">
        <div class="house">
          <p>卫生间</p>
          <ul>
            <li
              v-for="(item, index) in toilet"
              :key="index"
              @click="chooseToilet(item, index)"
              :class="{ houseActive: toiletIndex == index }"
            >
              {{ item }}
            </li>
          </ul>
        </div>
        <div class="house">
          <p>阳台</p>
          <ul>
            <li
              v-for="(item, index) in balcony"
              :key="index"
              @click="chooseBalcony(item, index)"
              :class="{ houseActive: balconyIndex == index }"
            >
              {{ item }}
            </li>
          </ul>
        </div>
      </template>

      <div class="price" v-if="area <= 140">
        <p>预算金额</p>
        <span>￥：{{ priceSum }}元 <span>（参考价）</span> </span>
      </div>
      <div class="consultation" v-else>
        <p>140m²以上请咨询</p>
        <div>
          <span>电话：</span> <a href="tel:400-800-5611">400-800-5611</a>
        </div>
      </div>
    </section>
    <footer>
      <ul>
        <li @click="itemDetails">
          <p><img src="../assets/img/mingxi.svg" alt="" /></p>
          <span>项目明细</span>
        </li>
        <li @click="accessoryBrand">
          <p><img src="../assets/img/pinpai.svg" alt="" /></p>
          <span>辅材品牌</span>
        </li>

        <li @click="moreChoose">
          <p><img src="../assets/img/gengduo.svg" alt="" /></p>
          <span>更多选择</span>
        </li>
      </ul>
    </footer>
    <!-- 弹窗 -->
    <van-overlay :show="show" @click="show = false">
      <div class="wrapper">
        <div class="postForm" @click.stop>
          <van-form @submit="onSubmit" @failed="onFailed">
            <van-field
              v-model="username"
              name="name"
              required
              label="用户名:"
              placeholder="请输入用户名"
              :rules="[{ required: true, message: '请填写用户名' }]"
            />
            <van-field
              v-model="phone"
              required
              label="手机号:"
              placeholder="请输入手机号"
              name="phone"
              :rules="[{ validator, message: '请输入正确内容' }]"
            />

            <van-field
              required
              v-model="code"
              center
              name="code"
              label="短信验证码:"
              placeholder="请输入短信验证码"
            >
              <template #button>
                <van-button
                  @click="verificationCode"
                  size="mini"
                  v-if="showCode"
                  color="#ffe001"
                  style="color: #000"
                  class="sendCode"
                >
                  获取验证码
                </van-button>
                <van-button size="small" v-else color="#e0e0e0">
                  <van-count-down
                    ref="countDown"
                    millisecond
                    :time="60000"
                    :auto-start="false"
                    format="ss"
                    @finish="finish"
                  />
                </van-button>
              </template>
            </van-field>

            <van-button
              class="submit"
              round
              block
              type="info"
              native-type="submit"
              >提交</van-button
            >
          </van-form>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Vue from "vue";
import { Toast } from "vant";
import { Picker } from "vant";
import { create, all } from "mathjs";
import { Form } from "vant";
import { Field } from "vant";
Vue.use(Form);
Vue.use(Field);

const config = {
  number: "BigNumber",
  epsilon: 1e-12,
  matrix: "Matrix",
  precision: 14,
  predictable: false,
  randomSeed: null,
};
const math = create(all, config);

Vue.use(Picker);
export default {
  props: {},
  data() {
    return {
      show: false,
      showCode: true,
      username: "",
      phone: "",
      code: "",
      houseIndex: "0",
      // 税金
      Taxes: "",
      // 管理费
      managementFees: "",
      area: "70",
      // sumPrice: "18800",
      path: "",
      BasePrice: 89999,
      overPrice: 899,
      toiletIndex: 0,
      balconyIndex: 0,
      roomType: "一卫一阳台",
      toilet: ["一卫", "二卫", "三卫"],
      toiletValue: "一卫",
      balcony: ["一阳台", "二阳台", "三阳台"],
      balconyValue: "一阳台",
      house: [
        {
          title: "899套餐",
          BasePrice: 89999,
          overPrice: 8999,
        },
        {
          title: "1499套餐",
          BasePrice: 149999,
          overPrice: 14999,
        },
      ],

      // 899一房一价表
      roomPrice: [
        {
          area: 30,
          price: 85426,
        },
        {
          area: 31,
          price: 85881,
        },
        {
          area: 32,
          price: 86336,
        },
        {
          area: 33,
          price: 86791,
        },
        {
          area: 34,
          price: 87246,
        },
        {
          area: 35,
          price: 87701,
        },
        {
          area: 36,
          price: 88156,
        },
        {
          area: 37,
          price: 88611,
        },
        {
          area: 38,
          price: 89066,
        },
        {
          area: 39,
          price: 89521,
        },
        {
          area: 40,
          price: 89976,
        },
        {
          area: 41,
          price: 90431,
        },
        {
          area: 42,
          price: 90886,
        },
        {
          area: 43,
          price: 91341,
        },
        {
          area: 44,
          price: 91796,
        },
        {
          area: 45,
          price: 92251,
        },
        {
          area: 46,
          price: 92706,
        },
        {
          area: 47,
          price: 93161,
        },
        {
          area: 48,
          price: 93616,
        },
        {
          area: 49,
          price: 94071,
        },
        {
          area: 50,
          price: 94526,
        },
        {
          area: 51,
          price: 95095,
        },
        {
          area: 52,
          price: 95663,
        },
        {
          area: 53,
          price: 96232,
        },
        {
          area: 54,
          price: 96801,
        },
        {
          area: 55,
          price: 97370,
        },
        {
          area: 56,
          price: 97938,
        },
        {
          area: 57,
          price: 98507,
        },
        {
          area: 58,
          price: 99076,
        },
        {
          area: 59,
          price: 99531,
        },
        {
          area: 60,
          price: 100100,
        },
        {
          area: 61,
          price: 100327,
        },
        {
          area: 62,
          price: 100555,
        },
        {
          area: 63,
          price: 100782,
        },
        {
          area: 64,
          price: 101010,
        },
        {
          area: 65,
          price: 101237,
        },
        {
          area: 66,
          price: 101465,
        },
        {
          area: 67,
          price: 101692,
        },
        {
          area: 68,
          price: 101920,
        },
        {
          area: 69,
          price: 102147,
        },
      ],
    };
  },
  mounted() {},
  methods: {
    chooseToilet(item, index) {
      this.toiletIndex = index;
      this.toiletValue = item;
      this.roomType = this.toiletValue + this.balconyValue;
    },
    chooseBalcony(item, index) {
      this.balconyIndex = index;
      this.balconyValue = item;
      this.roomType = this.toiletValue + this.balconyValue;
    },

    // blur事件
    blurText() {
      if (this.area == "") {
        Toast({
          message: "请输入房屋面积",
          position: "top",
        });
      } else if (this.area <= 0) {
        Toast({
          message: "请输入正确房屋面积",
          position: "top",
        });
      } else if (this.area < 30) {
        Toast({
          message: "不足30m²按30m²计算",
          position: "top",
        });
      } else if (this.area >= 30 && this.area < 70) {
      } else if (this.area > 140) {
        Toast({
          message: "140以上暂无报价",
          position: "top",
        });
      }
    },

    // 路由跳转
    itemDetails() {
      if (localStorage.getItem("name") != null) {
        this.$router.push("/itemDetails");
      } else {
        this.path = "/itemDetails";
        this.show = true;
        Toast({
          position: "top",
          message: "填写信息之后才能查看",
        });
      }
    },
    accessoryBrand() {
      if (localStorage.getItem("name") != null) {
        this.$router.push("/accessoryBrand");
      } else {
        this.show = true;
        this.path = "/accessoryBrand";
        Toast({
          position: "top",
          message: "填写信息之后才能查看",
        });
      }
    },
    moreChoose() {
      if (localStorage.getItem("name") != null) {
        this.$router.push({
          name: "moreChoose",
          params: {
            area: this.area,
            roomType: this.roomType,
            priceSum: this.priceSum,
            Taxes: this.Taxes,
            managementFees: this.managementFees,
          },
        });
      } else {
        this.show = true;
        this.path = "moreChoose";
        Toast({
          position: "top",
          message: "填写信息之后才能查看",
        });
      }
    },
    validator(val) {
      return /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-79])|(?:5[0-35-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[189]))\d{8}$/.test(
        val
      );
    },
    // 发送验证码
    verificationCode() {
      if (this.username && this.validator(this.phone)) {
        this.showCode = false;
        this.$nextTick(() => {
          this.$refs.countDown.start();
        });
        this.getCode();
      } else {
        Toast({
          position: "top",
          message: "填写有误,请重新填写",
        });
      }
    },
    // 倒计时结束
    finish() {
      this.showCode = true;
    },

    // 提交
    onSubmit(values) {
      this.givenCode(values);
    },
    onFailed(errorInfo) {
      Toast({
        position: "top",
        message: "填写有误,请重新填写",
      });
    },
    // 获取验证码
    async getCode() {
      const res = await this.$http.get("/sms", {
        params: { phone: this.phone },
      });

      Toast({
        position: "top",
        message: "获取验证码成功",
      });
    },

    async givenCode(value) {
      const res = await this.$http.get("/verification", {
        params: value,
      });
      Toast({
        position: "top",
        message: `${res.data.msg}`,
      });
      if (res.data.code == 0) {
        localStorage.setItem("name", this.username);
        this.username = "";
        this.phone = "";
        this.code = "";
        this.show = false;
        this.showCode = true;
        if (this.path == "/itemDetails") {
          this.$router.push("/itemDetails");
        } else if (this.path == "/accessoryBrand") {
          this.$router.push("/accessoryBrand");
        } else if (this.path == "moreChoose") {
          this.$router.push({
            name: "moreChoose",
            params: {
              area: this.area,
              roomType: this.roomType,
              priceSum: this.priceSum,
              Taxes: this.Taxes,
              managementFees: this.managementFees,
            },
          });
        } else {
          return false;
        }
      }
    },
  },
  computed: {
    // 价格计算
    priceSum() {
      if (this.area <= 0 || this.area > 140) return;
      // if (this.area > 140) return;
      if (this.area > 0 && this.area < 70) {
        // 899
        // if (this.houseIndex == 0) {
        if (this.area < 30) {
          Toast({
            message: "不足30m²按30m²计算",
            position: "top",
          });
          this.area = 30;
        }
        if (this.area.toString().indexOf(".") != -1) {
          Toast({
            message: "30m²-70m²取整计算",
            position: "top",
          });
          this.area = Math.ceil(this.area);
        }
        let newArr = this.roomPrice.filter((item) => {
          return item.area == this.area;
        });
        return newArr[0].price;
        // } else {
        //   // 1499
        //   Toast("暂无报价");
        //   return "";
        // }
      } else {
        // 基础价格
        let A = math.evaluate(this.BasePrice);
        // 超出套餐上价格
        let B = math.evaluate((this.area - 70) * this.overPrice);
        // 管理费 （a+b）*0.1
        let C = math.evaluate((Number(A) + Number(B)) * 0.1);
        this.managementFees = C.toFixed(2);
        // 超出卫生间和阳台价格
        let D = math.evaluate(
          this.balconyIndex * 9980 + this.toiletIndex * 16880
        );
        // 税金
        let E = math.evaluate(
          (Number(A) + Number(B) + Number(C) + Number(D)) * 0.0341
        );
        this.Taxes = E.toFixed(2);
        let F = math.evaluate(
          Number(A) + Number(B) + Number(C) + Number(D) + Number(E)
        );
        return Number(F).toFixed(2);
      }
    },
  },

  components: {},
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}
.main {
  width: 100%;
  background-color: #f2f5f9;
  padding: 30px 15px 0px;
  header {
    width: 100%;
    display: flex;
    margin-bottom: 25px;
    justify-content: space-between;
    padding-right: 15px;
    p {
      font-size: 19px;
      color: #333;
      font-weight: bold;
    }
    .van-icon-home-o {
      font-size: 30px;
    }
  }
}
section {
  width: 100%;
  padding: 15px;
  background-color: #fff;
  border-radius: 25px;
  .area {
    width: 100%;
    p {
      font-size: 14px;
      color: #333;
      font-weight: bold;
      margin: 10px 0px 15px 0px;
    }
    div {
      width: 100%;
      padding-right: 25px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 1px solid #dadaed;
      height: 30px;
      border-radius: 25px;
      input {
        width: 80%;
        height: auto;
        border: none;
        text-align: center;
        margin-left: 5px;
      }
    }
  }
  .house {
    width: 100%;
    p {
      font-size: 14px;
      color: #333;
      font-weight: bold;
      margin: 10px 0px 15px 0px;
    }
    ul {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 15px;
      li {
        width: 100%;
        height: 30px;
        border-radius: 15px;
        display: grid;
        place-items: center;
        border: none;
        background: #f7f7ff;
        color: #303232;
        font-size: 13px;
      }
      .houseActive {
        background-color: #ffe001;
        // color: #fff;
        font-weight: bold;
      }
    }
  }
  .houseRoom {
    p {
      font-size: 14px;
      color: #333;
      font-weight: bold;
      margin: 10px 0px 10px 0px;
    }
    ::v-deep .van-cell {
      width: 60%;
      height: 40px;
      padding: 0 1rem;
      display: flex;
      align-items: center;
      &::after {
        border: none;
      }
    }
    ::v-deep .van-field__label {
      width: 60px;
      font-weight: bold;
      color: #444;
    }
  }
  .price {
    width: 100%;
    padding-bottom: 10px;
    p {
      font-size: 14px;
      color: #333;
      font-weight: bold;
      margin: 20px 0px 10px 0px;
    }
    span {
      // width: 100%;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      // display: block;
      color: #c1272d;
      font-size: 20px;
      font-weight: bold;
      text-align: center;
      span {
        font-size: 16px;
      }
    }
  }
  .consultation {
    width: 100%;
    padding-top: 20px;
    padding-bottom: 15px;
    p {
      font-size: 16px;
      color: #333;
      font-weight: bold;
      margin: 10px 0px 20px 0px;
    }
    div {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        color: #c1272d;
        font-weight: bold;
        font-size: 18px;
        line-height: 1;
      }
      a {
        color: #c1272d;
        font-size: 20px;
        font-weight: bold;
        line-height: 1;
      }
    }
  }
}

footer {
  width: 100%;
  padding: 15px;
  background-color: #fff;
  border-radius: 20px;
  margin: 20px 0;

  ul {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    li {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        width: 38px;
      }
      span {
        margin: 10px 0 0 0;
        color: #808080;
        font-size: 14px;
      }
    }
  }
}
.postForm {
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
  padding: 15px;
  background-color: #fff;
  ::v-deep .van-cell {
    .van-field__label {
      width: auto;
      span {
        font-size: 11px;
        // font-weight: bold;
        color: #000;
      }
    }
    .van-field__control {
      &::placeholder {
        font-size: 10px;
        font-weight: 400;
      }
    }
    .van-button {
      width: 75px;
      height: 25px;
      color: #000 !important;
      font-size: 8px;
    }
  }

  .submit {
    margin-top: 10px;
    height: 40px;
    color: #000;
    background-color: #ffe001;
    border: none;
  }
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0px 10px;
}
.sendCode {
  font-size: 6px;
}
</style>
